// Copyright © 2021 Move Closer
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function loadScript(source) {
    return new Promise((resolve, reject) => {
        let el = document.querySelector(`script[src="${source}"]`);
        if (!el) {
            el = document.createElement('script');
            el.async = true;
            el.src = source;
            el.type = 'text/javascript';
            el.setAttribute('data-processing', 'true');
        }
        if (el.hasAttribute('data-error')) {
            reject(new Error('Already with error, not loaded'));
            return;
        }
        if (el.hasAttribute('data-loaded')) {
            resolve();
            return;
        }
        if (!el.hasAttribute('data-processing')) {
            setTimeout(() => resolve(), 1000);
            return;
        }
        el.addEventListener('error', function () {
            el.setAttribute('data-error', 'true');
            reject(new Error('Not loaded'));
        });
        el.addEventListener('abort', reject);
        el.addEventListener('load', function () {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            el.setAttribute('data-loaded', 'true');
            resolve();
        });
        document.body.appendChild(el);
    });
}
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export function unloadScript(source) {
    return new Promise((resolve, reject) => {
        const el = document.querySelector(`script[src="${source}"]`);
        if (typeof el === 'undefined' || !el) {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject();
            return;
        }
        document.body.removeChild(el);
        resolve();
    });
}
